// extracted by mini-css-extract-plugin
export default {"buttonGroup":"AttendanceTableActions_buttonGroup__0vv-2"};